import React, { useState, useEffect } from 'react';
import { AssignmentWizardPageProps } from '../AssignmentWizard';

export interface Grading5Props {
  manualGradeRelease: boolean;
  hideCommentResults?: boolean;
  hideGradeResults?: boolean;
  hideRatingResults?: boolean;
}

function GradingPage5({ assignmentSettings, updateSettings }: AssignmentWizardPageProps<Grading5Props>): JSX.Element {
  const [manualGradeRelease, setManualGradeRelease] = useState(assignmentSettings.manualGradeRelease);
  const [hideCommentResults, setHideCommentResults] = useState(assignmentSettings.hideCommentResults);
  const [hideGradeResults, setHideGradeResults] = useState(assignmentSettings.hideGradeResults);
  const [hideRatingResult, setHideRatingResult] = useState(assignmentSettings.hideRatingResults);

  // If completion grading is set, force hideGradeResults to false.
  useEffect(() => {
    if (assignmentSettings.completionGrading && !hideGradeResults) {
      setHideGradeResults(true);
      updateSettings({ ...assignmentSettings, hideGradeResults: true });
    }
  }, [assignmentSettings.completionGrading, hideGradeResults, updateSettings, assignmentSettings]);

  const handleSelectChange = (name: string, value: string) => {
    const booleanValue = value === 'true';
    if (name === 'hideRatingResults') {
      setHideRatingResult(booleanValue);
      updateSettings({ ...assignmentSettings, hideRatingResults: booleanValue });
    } else if (name === 'hideCommentResults') {
      setHideCommentResults(booleanValue);
      updateSettings({ ...assignmentSettings, hideCommentResults: booleanValue });
    } else if (name === 'hideGradeResults') {
      setHideGradeResults(booleanValue);
      updateSettings({ ...assignmentSettings, hideGradeResults: booleanValue });
    } else {
      setManualGradeRelease(booleanValue);
      updateSettings({ ...assignmentSettings, manualGradeRelease: booleanValue });
    }
  };

  return (
    <div id="advanced-visibility-settings-menu">
      <div className="visibility-text">
        <h3>Choose whether to show or hide ratings, comments, and/or grades from the student results page.</h3>
      </div>
      <div className="visibility-setting">
        <label htmlFor="manualGradeRelease">Grade Release</label>
        <select
          id="manualGradeRelease"
          name="manualGradeRelease"
          value={manualGradeRelease + ''}
          onChange={(e) => handleSelectChange(e.target.name, e.target.value)}
        >
          <option value="false">Automatic</option>
          <option value="true">Manual</option>
        </select>
      </div>
      <div className="visibility-setting">
        <label htmlFor="hideRatingResults">Rating Results</label>
        <select
          id="hideRatingResults"
          name="hideRatingResults"
          value={hideRatingResult + ''}
          onChange={(e) => handleSelectChange(e.target.name, e.target.value)}
        >
          <option value="false">Show</option>
          <option value="true">Hide</option>
        </select>
      </div>
      <div className="visibility-setting">
        <label htmlFor="hideCommentResults">Comment Results</label>
        <select
          id="hideCommentResults"
          name="hideCommentResults"
          value={hideCommentResults + ''}
          onChange={(e) => handleSelectChange(e.target.name, e.target.value)}
        >
          <option value="false">Show</option>
          <option value="true">Hide</option>
        </select>
      </div>
      {!assignmentSettings.completionGrading && (
        <div className="visibility-setting">
          <label htmlFor="hideGradeResults">Grade Results</label>
          <select
            id="hideGradeResults"
            name="hideGradeResults"
            value={hideGradeResults + ''}
            onChange={(e) => handleSelectChange(e.target.name, e.target.value)}
          >
            <option value="false">Show</option>
            <option value="true">Hide</option>
          </select>
        </div>
      )}
    </div>
  );
}

export default GradingPage5;
